module.exports = {
    //福利标签红点
    UPDATE_WELFARE_TAB_STATUS: "UPDATE_WELFARE_TAB_STATUS"
    //神格许愿状态
    , Update_Wish_Status: "Update_Wish_Status"
    //签到信息
    , Update_Sign_Info: "Update_Sign_Info"
    //领取签到奖励
    , Sign_Success: "Sign_Success"
    //等级礼包信息
    , Update_Lev_Gift: "Update_Lev_Gift"
    //更新某一个等级礼包信息
    , Update_Lev_Gift_Info: "Update_Lev_Gift_Info"
    //战力礼包信息
    , Update_Power_Gift: "Update_Power_Gift"
    //领取战力礼包
    , Update_Power_Gift_Info: "Update_Power_Gift_Info"
    //月卡信息
    , Update_Yueka: "Update_Yueka"
    , Update_Get_Yueka: "Update_Get_Yueka"//领取

    //召唤福利
    , Get_PartnerSummon_Data: "Get_PartnerSummon_Data"
    //问卷调查
    , Get_SureveyQuest_Basic: "Get_SureveyQuest_Basic"
    , Get_SureveyQuest_Topic_Content: "Get_SureveyQuest_Topic_Content"
    , Get_SureveyQuest_Get_Reward: "Get_SureveyQuest_Get_Reward"
    , SureveyQuest_Submit: "SureveyQuest_Submit"
    //周月福利
    , Updata_Week_Month_Data: "Updata_Week_Month_Data"
    //积天豪礼
    , Updata_Luxury_Data: "Updata_Luxury_Data"

    // 每日礼状态更新
    , Update_Daily_Awawd_Data: "Update_Daily_Awawd_Data"

    // 更新手机绑定状态
    , UpdateBindPhoneStatus: "UpdateBindPhoneStatus"

    //更新深海融合关注奖励按钮显示
    ,Update_SHRH_Award_Status:"Update_SHRH_Award_Status"

    ////更新深海融合关注领取奖励按钮显示
    ,Update_get_SHRH_Award_Status:"Update_get_SHRH_Award_Status"

    //更新深海融合分享奖励按钮状态
    ,Update_get_SHRH_share_award_status:"Update_get_SHRH_share_award_status"

    //更新深海小程序收藏奖励按钮状态
    ,Update_get_SHWX_collect_award_status:"Update_get_SHWX_collect_award_status"

    //更新深海小程序重新登陆检测场景值
    ,Update_SHWX_show_scene_val:"Update_SHWX_show_scene_val"
};